import {ListHeader} from './components/header/ListHeader'
import {BusinessCommentTable} from './BusinessCommentTable'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {ListViewProvider, useListView} from './core/ListViewProvider'
import {BusinessCommentEditModal} from './comment-add-edit/BusinessCommentEditModal'
import {KTCard} from '../../../../_metronic/helpers'

const BusinessCommentList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <ListHeader />
        <BusinessCommentTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <BusinessCommentEditModal />}
    </>
  )
}

const BusinessCommentListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <BusinessCommentList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {BusinessCommentListWrapper}
